import { useInfiniteQuery } from 'react-query';
import { positionUnwinderAxiosApi } from 'src/Config/axiosApi';
import { UnwindLogsPage } from '../types/unwind-logs.types';

/**
 * Reverse-chronological page loader for a single rule's dev-logs.
 * Backed by `GET /rules/:ruleId/logs?cursor=&count=` which reads from the
 * per-rule Redis Stream (PR 1) and will fall back to S3 for older ranges
 * once PR 2 lands.
 */
export function useUnwindLogs(
  ruleId: string,
  opts?: { count?: number; enabled?: boolean },
) {
  const count = opts?.count ?? 100;
  const enabled = (opts?.enabled ?? true) && !!ruleId;

  return useInfiniteQuery<UnwindLogsPage>(
    ['unwind-logs', ruleId, count],
    async ({ pageParam }) => {
      const { data } = await positionUnwinderAxiosApi.get<UnwindLogsPage>(
        `/rules/${encodeURIComponent(ruleId)}/logs`,
        {
          params: {
            count,
            ...(pageParam ? { cursor: pageParam } : {}),
          },
        },
      );
      return data;
    },
    {
      enabled,
      getNextPageParam: (last) => last.nextCursor ?? undefined,
      staleTime: 1000,
    },
  );
}
